import React from 'react'
import { technologies } from '../../Details'
import { BallCanvas } from './canvas'

const Tech = () => {
  return (
    <>
    <h1 className='flex justify-center pt-[40px] text-white text-3xl'>Skills</h1>
    <div className='flex md:px-[100px] pt-12 flex-row flex-wrap justify-center gap-10 '>
      {technologies.map((technology) => (
        <div className='w-28 h-28' key={technology.name}>
          <BallCanvas icon={technology.icon}/>
        </div>
      ))}
    </div>
    </>
  )
}

export default Tech